import { Contact } from "./Contact";
import { DateUtils } from "../utils/DateUtils";
import _ from "lodash";

export class FactureFournisseur {
    id?: number;
    client_id?: number;
    _client?: Contact;
    invoice_number?: string;
    invoice_date?: string;
    due_date?: string;
    invoice_issuer?: string;
    summary?: string;
    total_ht?: number;
    total_tva?: number;
    files: Array<any> = [];
    is_duplicated: boolean = false;
    created_at?: string;
    updated_at?: string;

    constructor(data: any) {
        _.assign(this, _.omit(data, ["client", "files"]));
        if (data.client) {
            this._client = new Contact(data.client);
        }
        if (data.files) {
            this.files = data.files;
        }
    }

    // Client getter/setter
    get client(): Contact | undefined {
        return this._client;
    }

    set client(value: Contact | undefined) {
        if (value) {
            this._client = value;
            this.client_id = value.id;
        }
    }

    // Date formatting getters
    get invoice_date_str(): string {
        if (this.invoice_date) {
            return DateUtils.sqlToDateStr(this.invoice_date, "DD/MM/YYYY");
        } else {
            return "";
        }
    }

    get due_date_str(): string {
        if (this.due_date) {
            return DateUtils.sqlToDateStr(this.due_date, "DD/MM/YYYY");
        } else {
            return "";
        }
    }

    get creation_date_str(): string {
        if (this.created_at) {
            return DateUtils.sqlToDateStr(this.created_at, "DD/MM/YYYY");
        } else {
            return "";
        }
    }

    // Serialize method for API calls
    serialize(): FactureFournisseur.IFactureFournisseur {
        return {
            id: this.id,
            client_id: this.client_id,
            invoice_number: this.invoice_number,
            invoice_date: this.invoice_date,
            due_date: this.due_date,
            invoice_issuer: this.invoice_issuer,
            summary: this.summary,
            total_ht: this.total_ht,
            total_tva: this.total_tva,
        };
    }
}

// Interface for serialization
export namespace FactureFournisseur {
    export interface IFactureFournisseur {
        id?: number;
        client_id?: number;
        invoice_number?: string;
        invoice_date?: string;
        due_date?: string;
        invoice_issuer?: string;
        summary?: string;
        total_ht?: number;
        total_tva?: number;
    }
}
